import Standard from './Standard';
import Advanced from './Advanced';
import Sticky from './Sticky';

const Popover = {
  Standard,
  Advanced,
  Sticky,
};

export default Popover;
